import {
	GuarantorEntityType,
	PatientEntityType,
	PractitionerEntityType,
} from "@/lib/supabase/supabaseTypes";
import { PdfLetterhead } from "../pdf-template-components/pdf-letterhead.component";
import { PdfLayout } from "../pdf-template-components/pdf-layout.component";
import { PdfRecipientAddress } from "../pdf-template-components/pdf-recipient-address.component";
import "../fonts.css";
import { PdfTemplateType } from "../document-template.types";
import { PaymentSlipDataInput } from "../pdf-template-components/qr-payment-slip/qr-payment-helpers";
import { PdfInvoiceBody } from "../pdf-template-components/pdf-invoice-body.component";
import { CommonPDFTemplateProps } from "./types";
import { PdfFooter } from "../pdf-template-components/pdf-footer.component";
import { getRecipient } from "../utils";
export interface KartenzahlungsquittungTemplateProps
	extends CommonPDFTemplateProps {
	patient?: PatientEntityType;
	guarantor?: GuarantorEntityType;
	practitioner?: PractitionerEntityType;
	paymentSlipData: PaymentSlipDataInput;
}

export const KartenzahlungsquittungTemplate: React.FC<
	KartenzahlungsquittungTemplateProps
> = ({
	client,
	job,
	jobDocument,
	jobItems,
	organization,
	pdfTemplateConfiguration,
	currencyConverterValues,
	patient,
	guarantor,
	practitioner,
	paymentSlipData,
	jobTotals,
}) => {
	if (
		!organization ||
		!pdfTemplateConfiguration ||
		!job ||
		!jobDocument ||
		!jobItems ||
		!client ||
		!paymentSlipData
	) {
		return null;
	}
	return (
		<PdfLayout pdfTemplateConfiguration={pdfTemplateConfiguration}>
			<PdfLetterhead
				organization={organization}
				pdfTemplateConfiguration={pdfTemplateConfiguration}
				pdfType={PdfTemplateType.KARTENZAHLUNGSQUITTUNG}
				mwstNumber={
					job.mwst_number ??
					client.mwst_number ??
					organization.mwst_number ??
					""
				}
			/>
			<PdfRecipientAddress
				recipient={getRecipient({
					job,
					patient,
					guarantor,
					client,
					templateType: PdfTemplateType.KARTENZAHLUNGSQUITTUNG,
				})}
				pdfTemplateConfiguration={pdfTemplateConfiguration}
				template={PdfTemplateType.KARTENZAHLUNGSQUITTUNG}
			/>
			<PdfInvoiceBody
				pdfTemplateConfiguration={pdfTemplateConfiguration}
				title="Kartenzahlungsquittung"
				client={client}
				job={job}
				jobDocument={jobDocument}
				jobItems={jobItems}
				patient={patient}
				paymentSlipData={paymentSlipData}
				organization={organization}
				jobTotals={jobTotals}
				practitioner={practitioner}
			/>
			<PdfFooter
				templateType={PdfTemplateType.KARTENZAHLUNGSQUITTUNG}
				pdfTemplateConfiguration={pdfTemplateConfiguration}
				client={client}
				currencyConverterValues={currencyConverterValues}
			/>
		</PdfLayout>
	);
};
